module.exports = __webpack_public_path__ + "static/media/person.b3c3ed72.svg";